module.exports = __webpack_public_path__ + "static/img/downloadLogo.525da0fd.png";